import { OnInit, Component, Input } from '@angular/core';
import PMSColor from 'src/app/model/company/pmscolor';
import Company from 'src/app/model/company/company';

@Component({
  selector: 'pms-color-list[inputCompany]',
  templateUrl: './pms-color-list.component.html',
  styleUrls: ['./pms-color-list.component.scss']
})
export class PmsColorListComponent implements OnInit {
  @Input()
  public inputCompany: Company;

  public nodes: Node[] = [];

  constructor() {}

  ngOnInit() {
    if (this.inputCompany.pmsColors == null) {
      this.inputCompany.pmsColors = [];
    }
    if (this.inputCompany.pmsColors.length > 0) {
      for (let i = 0; i < this.inputCompany.pmsColors.length; i++) {
        if (!this.inputCompany.pmsColors[i].archived) {
          this.nodes.push(new Node(this.inputCompany.pmsColors[i], i));
        }
      }
    }
  }

  addColor() {
    let newColor = new PMSColor();
    this.inputCompany.pmsColors.push(newColor);
    this.nodes.push(new Node(newColor, this.inputCompany.pmsColors.length - 1));
  }

  removeColor(i: number) {
    this.inputCompany.pmsColors.splice(i, 1);
    this.nodes = [];
    if (this.inputCompany.pmsColors.length > 0) {
      for (let i = 0; i < this.inputCompany.pmsColors.length; i++) {
        if (!this.inputCompany.pmsColors[i].archived) {
          this.nodes.push(new Node(this.inputCompany.pmsColors[i], i));
        }
      }
    }
  }
}

class Node {
  pmsColor: PMSColor;
  index: number;

  constructor(pmsColor: PMSColor, index: number) {
    this.pmsColor = pmsColor;
    this.index = index;
  }
}
